import moment from 'moment'
import KeywordSearchSanitize from './KeywordSearchSanitize'

/*
encodeFilter
*/
const encodeFilter = (type, value) => {
  if (type === 'keyword') {
    return '~' + value.trim()
  } else if (type === 'fulltext') {
    return KeywordSearchSanitize(value)
  } else if (type === 'slider-range') {
    return '|' + value.join('|')
  } else if (type === 'slider-range-years') {
    return 'd|' + value.map(v => moment().subtract(v, 'year').toISOString()).reverse().join('|')
  } else if (type === 'range-date') {
    return '|' + value.join('|')
  }
  return value
}

export default (filters, models) => {
  const newFilters = {}

  models.forEach((model) => {
    const target = model.target
    const value = filters[target]
    const type = model.type

    if (value) {
      newFilters[target] = encodeFilter(type, value)
    }
  })

  return newFilters
}



// WEBPACK FOOTER //
// ./src/utils/FilterfyToQuery.js